export const getFileFormat = (path: string | null): string | undefined => {
  if (!path) {
    return undefined;
  }
  const fileName = path.split("?")[0];
  const temp = fileName.split(".");
  return temp[temp.length - 1];
};
